"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_TIMER = exports.getTimeWithMoral = exports.getTime = void 0;
const moral_1 = require("./moral");
var TYPE_TIMER;
(function (TYPE_TIMER) {
    TYPE_TIMER["ACTION_FULL"] = "actionFull";
    TYPE_TIMER["ACTION"] = "action";
    TYPE_TIMER["BEFORE"] = "before";
    TYPE_TIMER["BETWEEN_GAME_LEAGUE"] = "betweenGameLeague";
    TYPE_TIMER["GAME"] = "game";
    TYPE_TIMER["INIT_LEAGUE"] = "initLeague";
    TYPE_TIMER["STANDUP"] = "standup";
    TYPE_TIMER["TD"] = "td";
    TYPE_TIMER["TURNOVER"] = "turnover";
    TYPE_TIMER["WAITING_GAME"] = "waitingGame";
    TYPE_TIMER["TIME_SEASON_IF_NO_LEAGUE"] = "timeSeasonIfNoLeague";
    TYPE_TIMER["HALF_TIME_GAME"] = "halfTime";
    TYPE_TIMER["HALF_TIME_PAUSE"] = "halfTimePause";
})(TYPE_TIMER || (exports.TYPE_TIMER = TYPE_TIMER = {}));
const getTime = (type) => {
    // Team actions: blitz, foul, pass, transmition
    // Player action
    // Player move = time / max move. Ex: move 6 -> 12/6 = 2h
    const TIME_ACTION_FULL = 3 * 60 * 60;
    const TIME_ACTION = 10 * 60 * 60;
    // Before game, setup
    const TIME_BEFORE = 3 * 60 * 60;
    const TIME_HALF_TIME_PAUSE = 3 * 60 * 60;
    // Total game time = TIME_BEFORE + TIME_GAME
    const TIME_GAME = 5 * 24 * 60 * 60;
    const TIME_HALF_TIME_GAME = 6 * 24 * 60 * 60;
    // Time of setup after a TD
    const TIME_TD = 3 * 60 * 60;
    // after turnover malus time for player actions
    const TIME_TURNOVER = 4 * 60 * 60;
    // how many hours a game stay pending
    const TIME_WAITING_GAME = 24;
    // before league games (last game end + 1 day)
    const TIME_INIT_LEAGUE = 1 * 24 * 60 * 60;
    // between each league games
    const TIME_BETWEEN_GAME_LEAGUE = TIME_GAME + 2 * 24 * 60 * 60;
    // 2 months
    const TIME_SEASON_IF_NO_LEAGUE = 60 * 24 * 60 * 30 * 2;
    switch (type) {
        case TYPE_TIMER.HALF_TIME_GAME:
            return TIME_HALF_TIME_GAME;
        case TYPE_TIMER.HALF_TIME_PAUSE:
            return TIME_HALF_TIME_PAUSE;
        case TYPE_TIMER.ACTION_FULL:
            return TIME_ACTION_FULL;
        case TYPE_TIMER.TIME_SEASON_IF_NO_LEAGUE:
            return TIME_SEASON_IF_NO_LEAGUE;
        case TYPE_TIMER.ACTION:
            return TIME_ACTION;
        case TYPE_TIMER.BEFORE:
            return TIME_BEFORE;
        case TYPE_TIMER.GAME:
            return TIME_GAME;
        case TYPE_TIMER.TD:
            return TIME_TD;
        case TYPE_TIMER.TURNOVER:
            return TIME_TURNOVER;
        case TYPE_TIMER.WAITING_GAME:
            return TIME_WAITING_GAME;
        case TYPE_TIMER.INIT_LEAGUE:
            return TIME_INIT_LEAGUE;
        case TYPE_TIMER.BETWEEN_GAME_LEAGUE:
            return TIME_BETWEEN_GAME_LEAGUE;
        default:
            return 0;
    }
};
exports.getTime = getTime;
const getTimeWithMoral = (type, moral = 100) => {
    const normalTime = getTime(type);
    const pourcMoral = (0, moral_1.getMalusFromMoral)(moral);
    return normalTime + (normalTime * pourcMoral) / 100;
};
exports.getTimeWithMoral = getTimeWithMoral;
